export default __webpack_public_path__ + "static/media/nphl_header_1.b34ba13e.jpg";